import React from "react";
import Login from "./Component";

const Container = () => {
  return <Login />;
};

export default Container;
